import React, { FC, ReactElement } from 'react'
import I18n from 'i18n'

export interface NoResultsRowProps {
  title: string
}

const NoResultsRow: FC<NoResultsRowProps> = ({ title = I18n.t('general.no_results') }): ReactElement => {
  return (
    <div className='row'>
      <div className='col s12'>
        <p>
          {title}
        </p>
      </div>
    </div>
  )
}

export default NoResultsRow
